import { Badge } from "@/components/ui/badge";
import { STAGE_META, gbp } from "@/utils/quoteStages";

export const QuoteStageBadge = ({ quote, showCode = false, testId }) => {
  if (!quote) return null;
  const meta = STAGE_META[quote.status] || STAGE_META.sent;
  const partPaid = quote.status !== "paid" && quote.status !== "refunded" && quote.amount_paid > 0 && quote.balance > 0;
  return (
    <span className="inline-flex items-center gap-1 flex-wrap" data-testid={testId}>
      {showCode && quote.quote_code && <span className="font-mono text-[10px] text-slate-500">{quote.quote_code}</span>}
      <Badge variant="outline" className={`text-[10px] ${meta.cls}`}>{meta.label}</Badge>
      {partPaid && (
        <Badge variant="outline" className="text-[10px] bg-amber-50 text-amber-800 border-amber-300" title={`${gbp(quote.amount_paid)} paid`}>
          Part paid · {gbp(quote.balance)} due
        </Badge>
      )}
    </span>
  );
};
